import { Col, Flex, Row } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Text, Title } from 'components/mvp-typography';
import PeopleLookingAtBrain from 'crx-clinic-management/src/img/people-looking-at-brain.png';
import { ConcussionRXLogo } from 'features/sign-in/v2/concussionRx-logo';
import { BarChart3, Bot, Brain } from 'lucide-react';
import { useHistory, useLocation } from 'react-router-dom';
import { routes } from 'routes';
import InfoCard from './InfoCard';
import { theme } from 'styles/colors';

export default function LandingPage() {
  const history = useHistory();
  const location = useLocation();

  function handleGetStarted() {
    history.push({
      pathname: routes.onboarding.registration,
      search: location.search
    });
  }

  return (
    <Row style={{ height: '100vh' }}>
      <Col
        span={12}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#e6f7ff'
        }}
      >
        {/* Placeholder for the image */}
        <img
          src={PeopleLookingAtBrain}
          alt="People looking at a brain"
          style={{ maxWidth: '100%', maxHeight: '100%' }}
        />
      </Col>
      <Col
        span={12}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '40px'
        }}
      >
        <Flex
          gap={16}
          vertical
          justify="space-between"
          style={{ height: '100%' }}
        >
          {/* ConcussionRx logo */}
          <Flex justify="center" style={{ marginTop: '1rem' }}>
            <ConcussionRXLogo style={{ width: 'unset', height: '50px' }} />
          </Flex>
          <Flex vertical gap={16}>
            {' '}
            {/* Title and subtitle */}
            <Title style={{ fontSize: '2em', marginBottom: '10px' }}>
              Welcome!
            </Title>
            <div style={{ fontWeight: 'light' }}>
              <Text>
                <span style={{ fontWeight: 'bold', color: theme.primary }}>
                  You
                </span>{' '}
                make the decisions,{' '}
                <span style={{ fontWeight: 'bold', color: theme.primary }}>
                  ConcussionRx
                </span>{' '}
                gives you the framework.
              </Text>
              <Text></Text>
            </div>
            {/* Three rounded cards - placeholders */}
            <Row gutter={[16, 16]} style={{ marginBottom: '30px' }}>
              <Col xl={24} xxl={8}>
                <InfoCard
                  icon={Brain}
                  title="Clinician led"
                  body="You remain the decision-maker. AI supports your clinical judgement."
                />
              </Col>
              <Col xl={24} xxl={8}>
                <InfoCard
                  icon={BarChart3}
                  title="Data-grounded"
                  body="Built on validated outcome measures. Results are multimodel, repeatable, and trackable."
                />
              </Col>
              <Col xl={24} xxl={8}>
                <InfoCard
                  icon={Bot}
                  title="Concussion-Focused Clinicial Decision Support"
                  body="Interprets patterns across systems. Every recommendation is tied to validated measures."
                />
              </Col>
            </Row>
            {/* Get started button */}
            <BaseButton
              type="primary"
              size="large"
              onClick={handleGetStarted}
              style={{ width: '200px' }}
            >
              Get Started
            </BaseButton>
          </Flex>
          <div />
        </Flex>
      </Col>
    </Row>
  );
}
